import React, { useEffect } from 'react';
import styled from "styled-components"
import {AiFillMail} from "react-icons/ai"
import ScrollToTop from 'react-scroll-to-top';

const Footer = () => {

  const gradientStyle = {
    background: 'linear-gradient(45deg, orangered, blue)', // Change colors as needed
    // Other styles can be added here
    height: '50px', // Example: Set the height to 100% of the viewport height
    width: "100px",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: "55px"
  };

  useEffect(() =>{
    window.scroll({
      top: 0,
      left: 100,
      behavior: "smooth"
    })
  })

  return (
    <Container>

        <Hold style={{marginBottom: "20px"}} href='https://gmail.com/cynthiadymphna04@gmail.com'>
            <AiFillMail style={{width: "35px", height: "35px"}}/>
            <Text>cynthiadymphna04@gmail.com</Text>
          </Hold>
            <ScrollToTop color='white' style={gradientStyle} smooth/> 
        <Line></Line>

        <Copyright>All right reserved 2023</Copyright>
      
      {/* </Wrapper> */}
    </Container>
  )
}

export default Footer;

const Container = styled.div`
width: 100%;
height: 90px;
display :flex;
flex-direction: column;
align-items: center;
justify-content: center;
top: 0;
background-color: black;
font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
`;
const Hold = styled.a`
width: auto;
height: auto;
color: #fff;
text-decoration: none;
/* background-color: red; */
display: flex;
justify-content: space-around;
align-items: center;
`;

const Text = styled.div`
font-size: 17px;

`;
const Line = styled.div`
width: 100%;
height: 1px;
background-color: #fff;
`;
const Copyright = styled.div`
color: #fff;
font-size: 16px;
margin-bottom: 6px;
`;

